import {BrowserModule} from "@angular/platform-browser"
import {NgModule} from "@angular/core"
import {ScrollToModule} from "@nicky-lenaers/ngx-scroll-to"
import {AppRoutingModule} from "./app-routing.module"

import {AppComponent} from "./app.component"
import {HttpClient, HttpClientModule} from "@angular/common/http"
import {BrowserAnimationsModule} from "@angular/platform-browser/animations"
import {ReactiveFormsModule} from "@angular/forms"
import {LoginComponent} from "./login/login.component"
import {ResetComponent} from "./reset/reset.component"
import {ResetRequestComponent} from "./reset-request/reset-request.component"
import {RegisterComponent} from "./register/register.component"
import {DisclaimerComponent} from "./components/disclaimer.component"
import {DialogModule} from "@angular/cdk-experimental/dialog";
import {TranslateHttpLoader} from "@ngx-translate/http-loader";
import {TranslateLoader, TranslateModule} from "@ngx-translate/core"

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        ResetComponent,
        ResetRequestComponent,
        RegisterComponent,
        DisclaimerComponent
    ],
    entryComponents: [
        DisclaimerComponent,
    ],
    imports: [
        BrowserModule,
        AppRoutingModule,
        HttpClientModule,
        BrowserAnimationsModule,
        ReactiveFormsModule,
        DialogModule,
        ScrollToModule.forRoot(),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [HttpClient]
            }
        })
    ],
    providers: [],
    bootstrap: [AppComponent]
})
export class AppModule {
}

export function HttpLoaderFactory(http: HttpClient) {
    return new TranslateHttpLoader(http)
}
